// Stored accounts use `kind`; the API exposes that field as `type` in the HUD.
// Credit balances are liabilities, regardless of their sign. Other accounts
// keep their signed balances so an overdraft still reduces available cash.
export interface CashAccount {
  kind?: string;
  type?: string;
  balance: unknown;
}

export const isCreditAccount = (account: Pick<CashAccount, "kind" | "type">): boolean =>
  (account.kind ?? account.type) === "credit";

const roundMoney = (amount: number): number => Math.round((amount + Number.EPSILON) * 100) / 100;

export function availableCash(accounts: readonly CashAccount[]): number {
  return roundMoney(accounts.reduce((total, account) => {
    const balance = Number(account.balance);
    return total + (!isCreditAccount(account) && Number.isFinite(balance) ? balance : 0);
  }, 0));
}

// Debit obligations already include repayments. Credit purchases stay separate
// and must never be deducted again from this cash forecast.
export const cashAfterDebits = (onHand: number, debitTotal: number): number =>
  roundMoney(onHand - debitTotal);
